<template>
  <slot>
    <div :id="identifier" class="form-engine-table" v-show="!state.hidden">
      <div class="idsk-table__heading">
        <slot name="heading">
          <span v-if="!state.hasHiddenCaption">
            <h2 class="govuk-heading-l govuk-!-margin-bottom-4">{{ t("Name", identifier) }}</h2>
            <p class="govuk-body" v-html="t('HelpText', identifier)"></p>
            <span :id="errorId" class="govuk-error-message">
              <ul v-if="currentErrors.length > 0">
                <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
                  {{ errorMessage.message }}
                </li>
              </ul>
            </span>
          </span>
        </slot>
      </div>
      <table class="govuk-table">
        <thead class="govuk-table__head">
          <slot name="header">
            <tr class="govuk-table__row">
              <th class="govuk-table__cell table-button-cell" v-if="!config.checkBoxColumn">
                <div class="govuk-checkboxes govuk-checkboxes--small">
                  <div class="govuk-checkboxes__item">
                    <input class="govuk-checkboxes__input" type="checkbox" v-model="allRowsSelected"
                      :disabled="!state.rows || state.rows.length === 0 || state.detailViewOpened" />
                    <div class="govuk-label govuk-checkboxes__label"></div>
                  </div>
                </div>
              </th>
              <th class="govuk-table__cell table-value-cell" v-for="(col, idx) in config.columns" :key="idx">
                {{ col.text }}
              </th>
            </tr>
          </slot>
        </thead>
        <tbody class="govuk-table__body" v-if="state.rows && state.rows.length > 0">
          <slot name="body">
            <tr :class="!row.valid ? 'govuk-table-row-error' : ''" v-for="row in state.rows" :key="row.rowNumber">
              <td class="govuk-table__cell table-button-cell" v-if="!config.checkBoxColumn">
                <div class="govuk-checkboxes govuk-checkboxes--small">
                  <div class="govuk-checkboxes__item">
                    <input class="govuk-checkboxes__input" type="checkbox" v-model="row.checked"
                      :disabled="state.detailViewOpened" />
                    <div class="govuk-checkboxes__label"></div>
                  </div>
                </div>
              </td>
              <td class="govuk-table__cell" v-for="(col, idx) in config.columns" :key="idx">
                <span>
                  {{ getFormattedCellValue(row, col) }}
                </span>

              </td>
            </tr>
          </slot>
        </tbody>
        <tbody class="govuk-table__body" v-else>
          <slot name="empty-body">
            <div style="height:30px"></div>
          </slot>
        </tbody>

      </table>
      <KeepAlive>
        <div class="idsk-table__meta" v-if="config.detail">
          <slot name="buttons">
            <div class="idsk-button-group idsk-table__meta-buttons" v-show="!state.detailViewOpened">
              <button type="submit" class="govuk-button" @click="openDetailView()">
                {{ t("addBtn", "_table") }}
              </button>
              <button type="submit" class="govuk-button govuk-button--secondary" @click="openDetailViewSelected()"
                :disabled="noRowSelected || multipleRowsSelected">
                {{ t("editBtn", "_table") }}
              </button>
              <button type="submit" class="govuk-button govuk-button--warning" @click="removeSelectedRows()"
                :disabled="noRowSelected">
                {{ t("removeBtn", "_table") }}
              </button>
            </div>
          </slot>
          <slot name="detail">
            <div class="table-edit-view" v-show="state.detailViewOpened">
              <accordion-section :identifier="config.detail.Identifier" :mtdt="detailMtdt" :level="level ? level + 1: 1">
                <template v-slot:content>
                  <recursive-component :structure="config.detail.Tree" :identifier="config.detail.Identifier"
                    :level="level ? level + 1: 1"></recursive-component>
                </template>
              </accordion-section>
              <div class="idsk-table-detail-buttons">
                <button type="submit" class="govuk-button" @click="saveDetailView()">
                  {{ t("saveDetailBtn", "_table") }}
                </button>
                <button type="submit" class="govuk-button" @click="closeDetailView()">
                  {{ t("closeDetailBtn", "_table") }}
                </button>
              </div>
            </div>
          </slot>
        </div>
      </KeepAlive>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/Table.ts"></script>
